import React from 'react';
import {Modal, Button, Row, Col, Container} from 'react-bootstrap';
import {FormField, Input} from "../index";

class Bookmark extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      name: ''
    }
  }

  render() {
    const { name } = this.state;
    const { show, setShow } = this.props;
    return (
        <Modal show={show} onHide={() => {setShow(false)}}>
          <Modal.Header closeButton>
            <Modal.Title>ذخیره جستجو</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col className={'mb-3'}>
                  <FormField>
                    <Input type={'text'} label={'عنوان'} placeholder={'عنوان'} value={name} onChange={(value) => {
                      this.setState({name: value})
                    }} />
                  </FormField>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {setShow(false)}}>
              انصراف
            </Button>
            <Button variant="primary" onClick={() => {setShow(name)}}>
              ذخیره
            </Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

export default Bookmark;
